import LoadService from 'services/loader-handler-services/load-service';
import Chaplin from 'chaplin';
import _ from 'lodash';
import EnrollmentDataService from 'services/data-handler-services/enrollment-data-service';

let courseSettings;
const CourseSettingsService = function () {
  if (CourseSettingsService.prototype._singleton) {
    return CourseSettingsService.prototype._singleton;
  }

  CourseSettingsService.prototype._singleton = this;

  this.files = {
    courseSettings: './content/course-settings.json',
  };
  this.initialize = function (settings) {
    return LoadService.load(this.files)
      .then(data => {
        let course = data.courseSettings;
        if (settings.env && course[settings.env]) {
          course = _.extend(course, course[settings.env]);
        }
        course = _.extend(course, settings);
        if (settings.available_languages) {
          const availableFallbackLanguages = course.supported_languages.filter(lang => lang.length === 2);
          course.supported_languages = _.uniq(
            settings.available_languages.reduce((langs, lang) => {
              if (course.supported_languages.includes(lang)) {
                langs.push(lang);
              } else if (availableFallbackLanguages.includes(lang.substring(0, 2))) {
                langs.push(lang.substring(0, 2));
              }
              return langs;
            }, [])
          );
          course.supported_languages.sort();
        }
        courseSettings = new Chaplin.Model(course);
      })
      .catch(err => console.info(err));
  };

  this.get = function (key) {
    return courseSettings && courseSettings.get(key);
  };

  this.getModel = function () {
    return courseSettings;
  };
  this.setDefaultConfigs = function () {
    const settings = {
      audio: {
        'audio-mute': this.getDefaultConfigs('settings.audio.audio-mute', 'audio-mute-default'),
        autoplay: this.getDefaultConfigs('settings.audio.autoplay', 'audio-autoPlay-default'),
        playbackRate: this.getDefaultConfigs('settings.audio.playbackRate', 'audio-playbackRate-default', 1),
      },
      video: {
        'video-mute': this.getDefaultConfigs('settings.video.video-mute', 'video-mute-default'),
        captions: this.getDefaultConfigs('settings.video.captions', 'video-captions-default'),
        'audio-description': this.getDefaultConfigs('settings.video.audio-description', 'video-audio-description'),
      },
    };
    EnrollmentDataService.saveData('settings', settings);
  };
  this.getDefaultConfigs = (setting, fallback, def) =>
    EnrollmentDataService.getByDotString(setting) ?? this.get('defaultConfigs')[fallback] ?? def ?? false;
};
export default new CourseSettingsService();
